import { render, staticRenderFns } from "./NewsOption.vue?vue&type=template&id=0347b99e&"
import script from "./NewsOption.vue?vue&type=script&lang=js&"
export * from "./NewsOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports